import Mutations from '../../odata/mutations';

export default { ...new Mutations('softSaleStockItemAudit'), ...new Mutations('softSaleStockItemAudits') };
